import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importMarketplaceActivityContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "MarketplaceActivityContainer" */
                '@perpay-web/fintech/components/containers/MarketplaceActivityContainer'
            ),
    );
